import { render, staticRenderFns } from "./RegisterCinco.vue?vue&type=template&id=abe5a12c"
import script from "./RegisterCinco.vue?vue&type=script&lang=js"
export * from "./RegisterCinco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports